import React from "react";

const Loader = () => {
  return <div style={bgStyles}></div>;
};

export default Loader;

const bgStyles = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 99999,
  background:
    " #fcfcfc url(https://meon.co.in/static/meon/img/preloader111.gif) no-repeat center center",
  backgroundSize: " 150px 150px",
  height: "100%",
  width: "100%",
  opacity: 0.8,
};
